import { gql } from '@apollo/client';

export const UPDATE_ADMIN = gql`
   mutation UpdateProfile($body: UpdateUserDetailDTO!) {
        updateProfile(body: $body) {
            data {
            _id
            access
            address
            contacts {
                dialCode
                email
                emailVerified
                number
            }
            email
            firstName
            lastName
            name
            role
            }
            message
        }
    }
`;

export const DELETE_ADMIN = gql`
    mutation ($id: String!) {
        removeAdmin(id: $id) {
            message
            admin {
                _id
            }
        }
    }
`;
